import axios from '../customAxios'
export default class BasicApiClass {
    constructor(params) {
        this.recurso = params.recurso ??  ''
        this.recursoMulti = params.recursoMulti ??  ''
    }

    load(filtros) {
        const apiUrl = `/api/listar-${this.recursoMulti}`
        return axios.post(apiUrl, filtros)
    }

    admin(formData) {
        const apiUrl = `/api/administrar-${this.recurso}`
        return axios.post(apiUrl, formData)
    }

    validarCuenta(formData) {
        const apiUrl = `/api/usuario/validar`
        return axios.post(apiUrl, formData)
    }

    updateWhitOutPass(formData) {
        const apiUrl = `/api/usuario/update`
        return axios.post(apiUrl, formData)
    }
    changePass(formData) {
        const apiUrl = `/api/usuario/change`
        return axios.post(apiUrl, formData)
    }

    adminPublico(formData) {
        const apiUrl = `/api/publico/administrar-${this.recurso}`
        return axios.post(apiUrl, formData)
    }
}

